import {CloudContract} from 'app/components/entities/cloud/model';
import {apiClient} from 'app/components/shared';

type PairingOptions = {
  name?: string;
  groupId?: string;
  addSeat?: boolean;
};

export class CloudApi {
  static async getPairingStats(teamId: string): Promise<CloudContract.PairedStats> {
    return apiClient.get<CloudContract.PairedStats>(
      `/front/api/v1t/team/${teamId}/devices/devicenumbers`,
    );
  }

  static async checkPairingCode(teamId: string, code: string): Promise<CloudContract.PairingCheck> {
    return apiClient.post<CloudContract.PairingCheck>(
      `/front/api/v1t/team/${teamId}/devices/prepair`,
      {
        pairing_code: code,
      },
    );
  }

  static async pairDevice(
    teamId: string,
    code: string,
    options?: PairingOptions,
  ): Promise<CloudContract.PairingSuccess> {
    return apiClient.post(`/front/api/v1t/team/${teamId}/devices/pair`, {
      PairingCode: code,
      Name: options?.name,
      GroupID: options?.groupId,
      AddSeat: options?.addSeat,
    });
  }
}
